import { useState } from "react";
import { apiFetch } from "../api";
import { theme } from "../theme";

// ── Add Product Modal ──────────────────────────────────────────────────────────
export default function AddProductModal({ token, onClose, onAdd, groups = [] }) {
  const [urls, setUrls] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [results, setResults] = useState(null);
  const [groupId, setGroupId] = useState("");   // platí pro celou dávku

  const handleAdd = async () => {
    const lines = urls.split("\n").map(l => l.trim()).filter(l => l.length > 0);
    if (lines.length === 0) { setError("Zadej alespoň jednu URL z Heureky."); return; }
    const invalid = lines.find(l => !l.includes("heureka.cz"));
    if (invalid) { setError("Všechny URL musí být z heureka.cz"); return; }
    setLoading(true); setError(""); setResults(null);

    const ok = [], fail = [];
    for (const line of lines) {
      try {
        const product = await apiFetch("/products", token, {
          method: "POST",
          body: JSON.stringify({
            heureka_url: line,
            group_id: groupId === "" ? null : Number(groupId),
          }),
        });
        onAdd(product);
        ok.push(product.name || line);
      } catch (e) {
        fail.push({ url: line, msg: e.message.includes("409") ? "Již sledováno" : e.message });
      }
    }

    setLoading(false);
    if (fail.length === 0) { onClose(); return; }
    setResults({ ok, fail });
  };

  if (results) return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000040", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100, padding: 24, backdropFilter: "blur(6px)" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: theme.bg, borderRadius: theme.rCard, width: "100%", maxWidth: 480, padding: 32, boxShadow: "0 24px 80px #00000020", fontFamily: theme.font }}>
        <h2 style={{ fontSize: 19, fontWeight: 700, marginBottom: 20, color: theme.ink }}>Výsledek importu</h2>
        {results.ok.length > 0 && <div style={{ background: theme.okSoft, border: `1px solid ${theme.okLine}`, borderRadius: theme.rCard, padding: 14, marginBottom: 12 }}>
          <p style={{ color: theme.ok, fontWeight: 700, fontSize: 13, marginBottom: 6 }}>✓ Přidáno ({results.ok.length})</p>
          {results.ok.map((n, i) => <p key={i} style={{ color: "#166534", fontSize: 12, marginBottom: 2 }}>{n}</p>)}
        </div>}
        {results.fail.length > 0 && <div style={{ background: theme.badSoft, border: `1px solid ${theme.badLine}`, borderRadius: theme.rCard, padding: 14, marginBottom: 20 }}>
          <p style={{ color: theme.bad, fontWeight: 700, fontSize: 13, marginBottom: 6 }}>✗ Chyba ({results.fail.length})</p>
          {results.fail.map((f, i) => <p key={i} style={{ color: "#991b1b", fontSize: 12, marginBottom: 2, wordBreak: "break-all" }}>{f.url} — {f.msg}</p>)}
        </div>}
        <button onClick={onClose} style={{ width: "100%", background: theme.blue, border: "none", borderRadius: theme.rBtn, padding: 12, color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Zavřít</button>
      </div>
    </div>
  );

  const count = urls.trim().split("\n").filter(l => l.trim()).length;

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "#00000040",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 100, padding: 24, backdropFilter: "blur(6px)",
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: theme.bg, borderRadius: theme.rCard, width: "100%", maxWidth: 480,
        padding: 32, boxShadow: "0 24px 80px #00000020",
        fontFamily: theme.font,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <h2 style={{ color: theme.ink, fontSize: 19, fontWeight: 700 }}>Přidat produkt</h2>
          <button onClick={onClose} style={{ width: 34, height: 34, borderRadius: theme.rBtn, border: `1.5px solid ${theme.line}`, background: theme.bg, color: theme.inkSoft, cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}><span style={{position:"relative",top:"-1px"}}>✕</span></button>
        </div>

        {groups.length > 0 && (
          <>
            <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: theme.inkSoft, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 8 }}>
              Skupina
            </label>
            <select
              value={groupId}
              onChange={e => setGroupId(e.target.value)}
              style={{ width: "100%", boxSizing: "border-box", padding: "11px 14px", borderRadius: 10, border: `1.5px solid ${theme.line}`, fontSize: 13.5, fontWeight: 600, color: theme.ink, background: theme.bgSoft, fontFamily: "inherit", cursor: "pointer", marginBottom: 6, outline: "none" }}
            >
              <option value="">Bez skupiny</option>
              {groups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
            </select>
            <p style={{ color: theme.mut, fontSize: 12, marginBottom: 18 }}>Platí pro všechny produkty přidané v této dávce.</p>
          </>
        )}

        <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: theme.inkSoft, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 8 }}>
          URL produktů z Heureky
        </label>
        <textarea
          value={urls}
          onChange={e => setUrls(e.target.value)}
          placeholder="https://www.heureka.cz/mobilni-telefony/samsung-galaxy-s24/"
          rows={5}
          style={{
            width: "100%", border: "1.5px solid " + (error ? theme.badLine : theme.line),
            borderRadius: 10, padding: "11px 14px", fontSize: 13,
            fontFamily: theme.font, color: theme.ink,
            background: theme.bgSoft, marginBottom: error ? 8 : 16,
            resize: "vertical", boxSizing: "border-box",
          }}
          onFocus={e => e.target.style.borderColor = theme.blue}
          onBlur={e => e.target.style.borderColor = error ? theme.badLine : theme.line}
        />
        {error && <p style={{ color: theme.bad, fontSize: 13, marginBottom: 14 }}>{error}</p>}
        <p style={{ color: theme.mut, fontSize: 13, marginBottom: 24, lineHeight: 1.5 }}>
          Vlož jednu nebo více URL — každou na nový řádek. Název se načte automaticky.
        </p>

        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{
            flex: 1, background: theme.bg, border: `1.5px solid ${theme.line}`,
            borderRadius: theme.rBtn, padding: "12px", color: theme.inkSoft,
            fontSize: 14, fontWeight: 600, fontFamily: theme.font,
          }}>Zrušit</button>
          <button onClick={handleAdd} disabled={loading} style={{
            flex: 2, background: `linear-gradient(135deg, ${theme.blue}, ${theme.blueDark})`,
            border: "none", borderRadius: theme.rBtn, padding: "12px", color: "#fff",
            fontSize: 14, fontWeight: 700, boxShadow: "0 4px 16px #126DFB30",
            fontFamily: theme.font, opacity: loading ? 0.7 : 1,
          }}>
            {loading ? "Přidávám…" : count > 1 ? `Přidat ${count} produktů` : "Přidat produkt"}
          </button>
        </div>
      </div>
    </div>
  );
}
